import { trace } from '@dvag/dfs-monitoring-sdk-fe';
import type { Attributes } from '@dvag/dfs-monitoring-sdk-fe';

export const getMonitoring = () => {
  const tracer = trace.getTracer('dfs-person-fe');

  const trackEvent = (event: { name: string; properties: Attributes }) => {
    const activeSpan = trace.getActiveSpan();

    if (activeSpan) {
      activeSpan.addEvent(event.name, event.properties);
      return;
    }

    const span = tracer.startSpan(event.name);

    try {
      span.addEvent(event.name, event.properties);
    } finally {
      span.end();
    }
  };

  const trackException = (error: unknown) => {
    if (error instanceof Error) {
      trace.getActiveSpan()?.recordException(error);
    }
  };

  return { trackEvent, trackException };
};
